<template>
  <div class="login-container">
    <van-nav-bar title="用户登录" />
    <van-form @submit="onSubmit" class="login-form">
      <van-cell-group inset>
        <van-field
          v-model="username"
          name="username"
          label="用户名"
          placeholder="请输入用户名"
          :rules="[{ required: true, message: '请填写用户名' }]"
          label-width="5em"
          clearable
        />
        <van-field
          v-model="password"
          type="password"
          name="password"
          label="密码"
          placeholder="请输入密码"
          :rules="[{ required: true, message: '请填写密码' }]"
          label-width="5em"
          clearable
        />
      </van-cell-group>
      <div style="margin: 16px;">
        <van-button round block type="primary" native-type="submit" :loading="loading" class="login-button">
          登录
        </van-button>
      </div>
    </van-form>
  </div>
</template>

<script setup>
import { showNotify } from 'vant';
import { ref } from 'vue';
import { useRouter } from 'vue-router';
// Changed import:
import { login as apiLogin } from '../services/api'; // Use named import, optionally alias if 'login' name conflicts

const username = ref('');
const password = ref('');
const loading = ref(false);
const router = useRouter();

const onSubmit = async () => {
  console.log('LOGIN.VUE ONSUBMIT - VERSION 002 --- TRYING SHOWNOTIFY');
  loading.value = true;
  try {
    console.log('Login.vue: Attempting apiLogin'); // Adjusted log
    // Changed call:
    const response = await apiLogin({ username: username.value, password: password.value }); 
    console.log('Login.vue: apiLogin successful, response:', JSON.parse(JSON.stringify(response)));

    // ... rest of the onSubmit function remains the same ...
    if (!response || !response.data) {
        console.error('Login.vue: Invalid response or response.data from apiLogin');
        showNotify({ type: 'danger', message: '登录响应无效' });
        loading.value = false;
        return;
    }
    console.log('Login.vue: response.data:', JSON.parse(JSON.stringify(response.data)));

    if (typeof response.data.token !== 'string' || response.data.token.length === 0) {
        console.error('Login.vue: Invalid or missing token in response.data:', response.data.token);
        showNotify({ type: 'danger', message: '登录凭证获取失败' });
        loading.value = false;
        return;
    }
    console.log('Login.vue: Token received:', response.data.token);
    localStorage.setItem('token', response.data.token);
    console.log('Login.vue: Token stored in localStorage');

    if (response.data.username) {
        localStorage.setItem('username', response.data.username);
        console.log('Login.vue: Username stored in localStorage:', response.data.username);
    } else {
        console.warn('Login.vue: Username missing in response.data');
    }

    console.log('Login.vue: Attempting to show success Notify');
    showNotify({ type: 'success', message: '登录成功' });
    console.log('Login.vue: Success Notify shown');

    console.log('Login.vue: Attempting router.push("/")');
    router.push('/');
    console.log('Login.vue: router.push("/") command sent');

  } catch (error) {
    console.error("Login.vue: Error caught in onSubmit. Message:", error.response?.data?.message || error.message, "Full error object:", error);
    let errorMessage = '登录失败，请检查凭据';
    if (error.response && error.response.data && typeof error.response.data.message === 'string') {
        errorMessage = error.response.data.message;
    } else if (error.message && typeof error.message === 'string') {
        errorMessage = error.message;
    }
    showNotify({ type: 'danger', message: errorMessage });
  } finally {
    loading.value = false;
    console.log('Login.vue: onSubmit finally block executed');
  }
};
</script>

<style scoped>
.login-container {
  padding-top: 20px;
}
.login-navbar .van-nav-bar__title {
    font-weight: bold;
}
.login-form {
  margin-top: 30px;
}
.form-cell-group .van-field__label { /* 确保标签文字清晰 */
  font-weight: 500;
}
.login-button { /* 确保按钮文字足够大 */
    font-weight: bold;
}
</style>
